<template>
    <div class="collect-data-container">
        <div class="overlay"></div>
        <div class="bg">
            <div v-if="!showGifts" class="form-coupon-container">
                <h2 v-if="!showInputPhone">{{ getString('informe_o_codigo_do_cupom') }}</h2>
                <h2 v-else>{{ getString('informe_seu_telefone') }}</h2>
                <div class="input-container" :class="hasError ? 'error-shake' : ''">
                    <div id="data" class="div-input-android" :class="{ 'error-signal': hasError }"></div>
                    <span class="message"> {{ message }}</span>
                </div>
                <div class="buttons-container">
                    <DefaultButton v-for="(btn, key) in getButtons()" :key="key" :disabled="!controlsEnabled"
                        :text="btn.text" @defaultBtnClick="btn.action()" class="buttons">
                    </DefaultButton>
                </div>

                <AndroidKeyboard id="android-keyboard" :inputElement="inputElement" :layout="layout"
                    :bigNumeric="true" :onInput="applyPhoneMask" :maxCaracteres="showInputPhone ? 15 : 6" :roundNumeric="isGomLayout"></AndroidKeyboard>
            </div>
            <!--<div v-else-if="availableCoupons && availableCoupons.length > 0" class="gifts-container">
                <div class="gifts-container-header">
                    <h2>{{ getString('selecione_o_cupom') }}</h2>
                    <button @click="cancel()"></button>
                </div>
                <AvailableCouponsCard v-for="(coupon, key) in availableCoupons" :key="key" :coupon="coupon" :saleValue="saleValue" @selectCoupon="selectCoupon" />
            </div>-->
            <div v-else class="gifts-container">
                <div class="gifts-container-header">
                    <h2>{{ getString('selecione_o_cupom') }}</h2>
                    <button @click="cancel()"></button>
                </div>
                <div class="gift-item" v-for="(gift, key) in validGiftData" :key="key">
                    <div class="gift-item-image">
                        <img :src="gift.image || junk" alt="Gift">
                    </div>
                    <div class="gift-item-content">
                        <div>
                            <div class="gift-item-description">{{ getGiftCode(gift) }}</div>
                            <div class="gift-item-desc">{{ buildDescription(gift) }}</div>
                            <div class="gift-item-expires_at" v-if="gift.expires_at">{{ formatDate(gift.expires_at) }}</div>
                        </div>
                        <div class="gift-item-button">
                            <button v-if="false">{{ getString('ver_regras') }}</button>
                            <button :disabled="gift.type === 'FREE_DELIVERY'" @click="selectGift(gift)">{{ getString('selecionar') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DefaultButton from '@/components/DefaultButton.vue'
import LocaleController from '@/assets/controllers/LocaleController'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import CashbackCampaingController from '@/assets/controllers/CashbackCampaingController'
import Util from '@/assets/libs/util'
import AvailableCouponsCard from '@/components/FidelityComponents/AvailableCouponsCard.vue'

export default {
    name: 'CoupomCodeModal',
    components: {
        DefaultButton,
        AndroidKeyboard,
        AvailableCouponsCard
    },
    props: ['phone'],
    data () {
        return {
            inputElement: null,
            visible: false,
            junk: require('../../../static/icons/junk-icon.png'),
            options: {
                useKbEvents: false,
                preventClickEvent: false
            },
            layout: keyboardLayout.SIMPLE_PHONE_NUMBER,
            input: null,
            phoneMask: '(##) #####-####',
            buttons: [
                {
                    text: this.getString('cancelar'),
                    action: this.cancel,
                    visible: true
                },
                {
                    text: this.getString('confirmar'),
                    action: this.confirm,
                    visible: true
                }
            ],
            hasError: false,
            controlsEnabled: true,
            message: '',
            validGiftData: null,
            showGifts: false,
            isGomLayout: Util.getLocalConfigs('utiliza_layout_gom') || false,
            availableCoupons: [],
            showInputPhone: false,
            phoneNumber: ''
        }
    },
    mounted () {
        this.inputElement = document.getElementById('data')
        this.availableCoupons = CashbackCampaingController.getCouponsAvailable()
        /* if (this.availableCoupons.length > 0) {
            this.showGifts = true
        } */
        // Inicializa o phoneNumber local com a prop phone
        this.phoneNumber = this.phone || ''
        if (!this.phoneNumber) {
            this.showInputPhone = true
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getButtons: function () {
            return this.buttons.filter(e => e.visible)
        },
        confirm: async function () {
            let value = this.inputElement.innerText
            if (this.showInputPhone) {
                if (!this.validPhoneNumber(value)) {
                    this.hasError = true
                    this.showError()
                    return false
                }
                this.phoneNumber = Util.sanitizePhoneNumber(this.inputElement.innerText)
                CashbackCampaingController.setPhone(this.phoneNumber)
                // Emite evento para atualizar o phone no componente pai
                this.$emit('update:phone', this.phoneNumber)
                this.showInputPhone = false
                this.inputElement.innerText = ''
                return true
            }

            this.controlsEnabled = false
            this.buttons[1].text = this.getString('aguarde')
            this.validGiftData = await this.validateCoupon(value)
            if (!this.validGiftData) {
                this.hasError = true
                this.showError()
                this.buttons[1].text = this.getString('confirmar')
                this.controlsEnabled = true
                return false
            }
            this.showGifts = true
        },
        cancel: function () {
            this.$emit('closeCoupomCodeModal')
        },
        validateCoupon: async function (value) {
            if (!value) {
                this.message = this.getString('informe_codigo_cupom')
                return false
            }
            if (value.length !== 6) {
                this.message = this.getString('codigo_cupom_invalido')
                return false
            }
            let result = await CashbackCampaingController.validateCoupon(value, this.phoneNumber)
            if (result.error) {
                this.message = result.message
                return false
            }
            if (!result) {
                this.message = this.getString('codigo_cupom_invalido')
                return false
            }
            return [result]
        },
        clearMessage: function () {
            setTimeout(() => {
                this.hasError = false
                this.message = ''
            }, 2000)
        },
        showError: function () {
            this.clearMessage()
        },
        formatDate: function (date) {
            if (!date) {
                return ''
            }
            return `${this.getString('valido_ate')} ${new Date(date).toLocaleDateString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`
        },
        formatMoney: function (value) {
            return Util.formatMoney(value)
        },
        selectGift: function (gift) {
            this.$emit('selectGift', gift)
        },
        buildDescription: function (gift) {
            let isCashback = gift.is_cashback === 'true' || gift.is_cashback === true
            let giftAmount = gift.amount
            let giftType = gift.type
            let giftAmountType = gift.amount_type
            let value = ''
            if (giftType !== 'CASHBACK_ACCUMULATE') {
                value = (['CASH', 'CASHBACK'].includes(giftAmountType) || isCashback) ? `${this.getString('desconto_cashback')} ${this.formatMoney(giftAmount)}` : `${this.getString('desconto_cashback')} ${giftAmount}%`
            } else {
                value = `${giftAmount}%`
            }
            let applied = ''
            if (giftType === 'CASHBACK_ACCUMULATE') {
                applied = `${this.getString('de_cashback_para_a_proxima_compra')}.`
            } else if (giftType === 'DISCOUNT_ORDER') {
                applied = `${this.getString('aplicado_no_total_do_pedido')}.`
            } else if (giftType === 'FREE_DELIVERY') {
                value = ''
                applied = `${this.getString('frete_gratis')}`
            } else if (giftType === 'PRODUCT_DISCOUNT') {
                applied = `${this.getString('aplicado_nos_produtos_selecionados')}.`
            }
            return `${value} ${applied}`
        },
        selectCoupon: async function (coupon) {
            console.log(coupon)
            // let teste = await this.validateCoupon(coupon.code, true)
        },
        getGiftCode: function (gift) {
            return gift.gift.description || gift.gift.gift.code || gift.gift.code || 'CUPOM'
        },
        validPhoneNumber: function (value) {
            return Util.validPhoneNumber(value)
        },
        applyPhoneMask: function (input) {
            if (this.showInputPhone) {
                if (!input) return ''
                input = input.replace(/\D/g, '')
                input = input.replace(/(\d{2})(\d)/, '($1) $2')
                input = input.replace(/(\d)(\d{4})$/, '$1-$2')
                return input
            } else {
                if (!input) return ''
                input = input.replace(/\D/g, '')
                return input
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../../assets/common.less");

.collect-data-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
    box-sizing: border-box;
    .bg {
        position: relative;
        background: @white;
        padding: 30px;
        border-radius: 25px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        max-width: calc(100vw - 300px);
        width: 100%;
        max-height: calc(100vh - 40px);
        overflow-y: auto;
        opacity: 1;
        z-index: 1000;
        min-height: 50vh;
        max-height: 80vh;
        overflow-y: auto;
        #android-keyboard {
            margin: 15px;
        }
        .form-coupon-container {
            img {
                display: block;
                margin: auto;
                width: 100px;
                height: 100px;
                border: solid 1px;
                border-radius: 100%;
                object-fit: contain;
                padding: 10px;
            }

            h2,
            span,
            img {
                display: block;
                font-size: 2rem;
                margin: auto;
                text-align: center;
                opacity: 1;
            }

            span {
                // line-height: 50px;
                margin: 0 15px;
            }

            h2,
            span.qst {
                margin: 15px 0;
                font-weight: bold;
            }

            .input-container {
                margin: 20px 15px;
                text-align: center;

                .div-input-android {
                    position: relative;
                    margin: 50px 0 20px 0;
                    display: block;
                    font-size: 4rem;
                    height: 85px;
                    background-color: white;
                    color: black;
                    border: 2px solid black;
                    border-radius: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &.error-shake {
                        input {
                            background-color: rgba(250, 9, 9, 0.397);
                        }

                        animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
                        transform: translate3d(0, 0, 0);
                    }
                }

                .message {
                    height: 28px;
                    font-size: 28px;
                }

                .error-signal {
                    border: 4px solid red;
                    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
                    transform: translate3d(0, 0, 0);
                }
            }

            .buttons-container {
                margin: 20px 20px 48px 20px;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-content: center;
                justify-content: space-between;
                align-items: center;

                button:not(:last-of-type) {
                    background: white;
                    border: solid 1px black;
                    color: black;
                }

                button {
                    // margin: 10px;
                    width: 46%;
                }
            }
        }
        .gifts-container {
            .gifts-container-header {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                margin: 20px 0;
                padding: 15px;
                margin-bottom: 30px;
                h2 {
                    font-size: 35px;
                    margin: 0;
                }
                button {
                    position: absolute;
                    right: 30px;
                    top: 30px;
                    font-size: 35px;
                    margin: -10px -10px;
                    padding: 10px 20px;
                    border-radius: 10px;
                    border: none;
                    // box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
                    background: none;
                    &:before {
                        content: "\2715";
                    }
                }
            }
            .gift-item {
                display: flex;
                flex-direction: row;
                align-items: start;
                margin: 20px 0;
                padding: 15px;
                box-shadow: 0px 5px 15px 0 rgba(0, 0, 0, 0.4);
                border-radius: 10px;
                height: auto;
                .gift-item-image {
                    margin: 0 20px 0 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 250px;
                    img {
                        width: 280px;
                        min-height: 250px;
                        object-fit: cover;
                        border-radius: 10px;
                    }
                }
                .gift-item-content {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 100%;
                    min-height: 250px;
                    .gift-item-name {
                        margin: 5px 0;
                        font-size: 30px;
                    }
                    .gift-item-description {
                        font-size: 35px;
                        font-weight: bold;
                    }
                    .gift-item-value {
                        margin: 5px 0;
                        font-size: 35px;
                    }
                    .gift-item-expires_at {
                        margin: 10px 0 15px 0;
                        font-size: 25px;
                        color: #5e5e5e;
                    }
                    .gift-item-desc {
                        margin: 10px 0 30px 0;
                        font-size: 25px;
                        color: #5e5e5e;
                    }
                    .gift-item-button {
                        display: flex;
                        flex-direction: row;
                        button {
                            font-size: 35px;
                            margin: 0;
                            padding: 10px 20px;
                            border-radius: 10px;
                            border: none;
                            box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
                            color: @white;
                            background: @primary-color;
                            width: 100%;
                        }
                    }
                }
            }

        }
    }

    .overlay {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 30;
        will-change: background-color;
        -webkit-transition: background-color 1s ease-in-out;
        transition: background-color 1s ease-in-out;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }

    #keyboard {
        .keyboard;
        width: inherit;
        max-width: 930px;
        top: inherit;
        position: unset;
        bottom: 0;
    }

    @keyframes shake {

        10%,
        90% {
            transform: translate3d(-1px, 0, 0);
        }

        20%,
        80% {
            transform: translate3d(2px, 0, 0);
        }

        30%,
        50%,
        70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%,
        60% {
            transform: translate3d(4px, 0, 0);
        }
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .collect-data-container {
        padding: 10px;

        .bg {
            padding: 15px;
            max-width: calc(100vw - 120px);
            border-radius: 10px;
            .form-coupon-container {
                img {
                    width: 50px;
                    height: 50px;
                    padding: 5px;
                }

                h2, span, img {
                    font-size: 1rem;
                }

                span {
                    margin: 0 8px;
                }

                h2, span.qst {
                    margin: 8px 0;
                }

                .input-container {
                    margin: 10px 8px;

                    .div-input-android {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 2rem;
                        height: 45px;
                        border-radius: 10px;
                    }

                    .message {
                        height: 15px;
                        font-size: 14px;
                    }

                    .error-signal {
                        border: 2px solid red;
                    }
                }

                .buttons-container {
                    margin: 10px 10px 24px 10px;

                    button {
                        width: 46%;
                    }
                }
            }

            .gifts-container {
                .gifts-container-header {
                    margin: 10px 0;
                    padding: 8px;
                    margin-bottom: 15px;

                    h2 {
                        font-size: 18px;
                    }

                    button {
                        right: 15px;
                        top: 15px;
                        font-size: 18px;
                        margin: -5px -5px;
                        padding: 5px 10px;
                        border-radius: 5px;
                    }
                }

                .gift-item {
                    margin: 10px 0;
                    padding: 8px;
                    border-radius: 5px;
                    flex-direction: row;

                    .gift-item-image {
                        margin: 0;
                        height: 80px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        align-self: center;
                        img {
                            width: 140px;
                            min-height: 80px;
                            border-radius: 5px;
                        }
                    }

                    .gift-item-content {
                        min-height: auto;

                        .gift-item-name {
                            margin: 3px 0;
                            font-size: 15px;
                        }

                        .gift-item-description {
                            font-size: 17px;
                        }

                        .gift-item-value {
                            margin: 3px 0;
                            font-size: 17px;
                        }

                        .gift-item-expires_at {
                            margin: 5px 0 8px 0;
                            font-size: 12px;
                        }

                        .gift-item-desc {
                            margin: 5px 0 15px 0;
                            font-size: 12px;
                        }

                        .gift-item-button button {
                            font-size: 16px;
                            padding: 5px 10px;
                            border-radius: 5px;
                            height: 30px;
                        }
                    }
                }
            }
        }
    }
}

@media (min-width: 901px) and (max-width: 1025px) {

    //@tablet
    .collect-data-container {
        padding: 17px;

        .bg {
            padding: 25px;
            max-width: calc(100vw - 250px);

            .form-coupon-container {
                img {
                    width: 85px;
                    height: 85px;
                    padding: 8px;
                }

                h2, span, img {
                    font-size: 1.7rem;
                }

                span {
                    margin: 0 13px;
                }

                h2, span.qst {
                    margin: 13px 0;
                }

                .input-container {
                    margin: 17px 13px;

                    .div-input-android {
                        margin: 42px 0 17px 0;
                        font-size: 3.4rem;
                        height: 72px;
                        border-radius: 17px;
                        padding: 0 17px;
                    }

                    .message {
                        height: 24px;
                        font-size: 24px;
                    }

                    .error-signal {
                        border: 3px solid red;
                    }
                }

                .buttons-container {
                    margin: 17px 17px 40px 17px;

                    button {
                        width: 46%;
                    }
                }
            }

            .gifts-container {
                .gifts-container-header {
                    margin: 17px 0;
                    padding: 13px;
                    margin-bottom: 25px;

                    h2 {
                        font-size: 30px;
                    }

                    button {
                        right: 25px;
                        top: 25px;
                        font-size: 30px;
                        margin: -8px -8px;
                        padding: 8px 17px;
                        border-radius: 8px;
                    }
                }

                .gift-item {
                    margin: 17px 0;
                    padding: 13px;
                    border-radius: 8px;

                    .gift-item-image {
                        margin: 0 17px 0 0;
                        height: 212px;

                        img {
                            width: 238px;
                            min-height: 212px;
                            border-radius: 8px;
                        }
                    }

                    .gift-item-content {
                        min-height: 212px;

                        .gift-item-name {
                            margin: 4px 0;
                            font-size: 25px;
                        }

                        .gift-item-description {
                            font-size: 30px;
                        }

                        .gift-item-value {
                            margin: 4px 0;
                            font-size: 30px;
                        }

                        .gift-item-expires_at {
                            margin: 8px 0 13px 0;
                            font-size: 21px;
                        }

                        .gift-item-desc {
                            margin: 8px 0 25px 0;
                            font-size: 21px;
                        }

                        .gift-item-button button {
                            font-size: 30px;
                            padding: 8px 17px;
                            border-radius: 8px;
                        }
                    }
                }
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 900px) {

    //@mehloretec
    .collect-data-container {
        padding: 15px;

        .bg {
            padding: 23px;
            max-width: calc(100vw - 200px);

            .form-coupon-container {
                img {
                    width: 75px;
                    height: 75px;
                    padding: 8px;
                }

                h2, span, img {
                    font-size: 1.5rem;
                }

                span {
                    margin: 0 11px;
                }

                h2, span.qst {
                    margin: 11px 0;
                }

                .input-container {
                    margin: 15px 11px;

                    .div-input-android {
                        margin: 38px 0 15px 0;
                        font-size: 3rem;
                        height: 64px;
                        border-radius: 15px;
                        padding: 0 15px;
                    }

                    .message {
                        height: 21px;
                        font-size: 21px;
                    }

                    .error-signal {
                        border: 3px solid red;
                    }
                }

                .buttons-container {
                    margin: 15px 15px 36px 15px;

                    button {
                        width: 46%;
                    }
                }
            }

            .gifts-container {
                .gifts-container-header {
                    margin: 15px 0;
                    padding: 11px;
                    margin-bottom: 23px;

                    h2 {
                        font-size: 26px;
                    }

                    button {
                        right: 23px;
                        top: 23px;
                        font-size: 26px;
                        margin: -8px -8px;
                        padding: 8px 15px;
                        border-radius: 8px;
                    }
                }

                .gift-item {
                    margin: 15px 0;
                    padding: 11px;
                    border-radius: 8px;

                    .gift-item-image {
                        margin: 0 15px 0 0;
                        height: 188px;

                        img {
                            width: 210px;
                            min-height: 188px;
                            border-radius: 8px;
                        }
                    }

                    .gift-item-content {
                        min-height: 188px;

                        .gift-item-name {
                            margin: 4px 0;
                            font-size: 23px;
                        }

                        .gift-item-description {
                            font-size: 26px;
                        }

                        .gift-item-value {
                            margin: 4px 0;
                            font-size: 26px;
                        }

                        .gift-item-expires_at {
                            margin: 8px 0 11px 0;
                            font-size: 19px;
                        }

                        .gift-item-desc {
                            margin: 8px 0 23px 0;
                            font-size: 19px;
                        }

                        .gift-item-button button {
                            font-size: 26px;
                            padding: 8px 15px;
                            border-radius: 8px;
                        }
                    }
                }
            }
        }
    }
}

@media (orientation: landscape) {
    .collect-data-container {
        padding: 15px;

        .bg {
            padding: 23px;
            max-width: calc(100vw - 225px);
            max-height: 90vh;

            .form-coupon-container {
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-template-rows: auto;
                grid-template-areas:
                    "title keyboard"
                    "input keyboard"
                    "buttons keyboard";
                gap: 10px 10px;
                align-items: center;
                min-height: 60vh;

                h2 {
                    grid-area: title;
                    font-size: 1.5rem;
                    margin: 0;
                    text-align: center;
                    align-self: self-center;
                }

                .input-container {
                    grid-area: input;
                    margin: 0;
                    align-self: self-start;

                    .div-input-android {
                        margin: 10px 0;
                        font-size: 2.5rem;
                        height: 64px;
                        border-radius: 15px;
                        padding: 0 15px;
                    }

                    .message {
                        height: 21px;
                        font-size: 21px;
                    }

                    .error-signal {
                        border: 3px solid red;
                    }
                }

                .buttons-container {
                    grid-area: buttons;
                    margin: 0;
                    display: flex;
                    flex-direction: column-reverse;
                    justify-content: space-evenly;
                    margin-bottom: 5px;
                    gap: 10px;
                    align-self: center;
                    button {
                        width: 100%;
                    }
                }

                #android-keyboard {
                    grid-area: keyboard;
                    margin: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    align-self: center;
                }

                img {
                    width: 75px;
                    height: 75px;
                    padding: 8px;
                }

                span {
                    margin: 0 11px;
                }

                span.qst {
                    margin: 11px 0;
                }
            }

            .gifts-container {
                .gifts-container-header {
                    margin: 15px 0;
                    padding: 11px;
                    margin-bottom: 23px;

                    h2 {
                        font-size: 26px;
                    }

                    button {
                        right: 23px;
                        top: 23px;
                        font-size: 26px;
                        margin: -8px -8px;
                        padding: 8px 15px;
                        border-radius: 8px;
                    }
                }

                .gift-item {
                    margin: 15px 0;
                    padding: 11px;
                    border-radius: 8px;

                    .gift-item-image {
                        margin: 0 15px 0 0;
                        height: 188px;

                        img {
                            width: 210px;
                            min-height: 188px;
                            border-radius: 8px;
                        }
                    }

                    .gift-item-content {
                        min-height: 188px;

                        .gift-item-name {
                            margin: 4px 0;
                            font-size: 23px;
                        }

                        .gift-item-description {
                            font-size: 26px;
                        }

                        .gift-item-value {
                            margin: 4px 0;
                            font-size: 26px;
                        }

                        .gift-item-expires_at {
                            margin: 8px 0 11px 0;
                            font-size: 19px;
                        }

                        .gift-item-desc {
                            margin: 8px 0 23px 0;
                            font-size: 19px;
                        }

                        .gift-item-button button {
                            font-size: 26px;
                            padding: 8px 15px;
                            border-radius: 8px;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/FidelityComponents/CoupomCodeModal.vue